// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__34Cdx","footer":"ModalCreateQualiphyProcedure_footer__KMiL4","additionData":"ModalCreateQualiphyProcedure_additionData__26Phu"};